/**
 * Tries to sniff from server error response whether or not it was blocked by Azure Web Application Firewall
 *
 * @param statusCode http status code from server response
 * @param headers http headers from server response
 * @returns true if blocked by WAF
 */
export function isWAFBlocked(
  statusCode: number,
  headers?: Record<string, string>
): boolean {
  return statusCode === 403 && /(azure|microsoft)/i.test(headers?.server ?? '');
}
